(function($) {

    // Get height of viewport
    heroHeight = function() {

        var viewportHeight = $(window).height();
        var headerHeight = $('.site-header').height();
        var heroBlock = $('.image-block.is-hero .bg-img');

        if ($(window).width() >= 1400) {
            heroBlock.css('height', viewportHeight - headerHeight);
        } else {
            heroBlock.css('height', 'auto');
        }

    };
    heroHeight();

    $(window).resize(function() {
        heroHeight();
    });

    $('.img-overlay .overlay-list li a').on('click', function(elm) {
		let href = $(this).attr('href');
		if (href.charAt(0) === '#') {
			$('html, body').animate({
				scrollTop: $(href).offset().top
			}, 500);
		}
    });

})(jQuery);